import React from "react";

type SVGType = {
  name?:
    | "alarmWhite" // 0 0 28 28
    | "fileDownload" // 0 0 20 20
    | "imgDownload" // 0 0 20 20
    | "listView" // 0 0 24 24
    | "listViewActive" // 0 0 24 24
    | "gridView" // 0 0 24 24
    | "gridViewActive" // 0 0 24 24
    | "alarmBlack"
    | "userWhite"
    | "userBlack"
    | "setting"
    | "more"
    | "pin"
    | "pinActive"
    | "logout"
    | "back"
    | "camera"
    | "send"
    | "expand" // 0 0 58 58
    | "reduce" // 0 0 58 58
    | "checkbox" // 0 0 20 20
    | "checkboxActive" // 0 0 20 20
    | "roundCheckbox" // 0 0 24 24
    | "roundCheckboxActive" // 0 0 24 24
    | "lineCheckboxActive" // 0 0 24 24
    | "modalClose" // 0 0 24 24
    | "imageModalClose" // 0 0 24 24
    | "iconAs" // 0 0 32 32
    | "iconComment" // 0 0 32 32
    | "iconDoc" // 0 0 32 32
    | "switch" // 0 0 51 25
    | "switchActive" // 0 0 51 25
    | "chat" // 2 1 12.967 13.204
    | "chatActive" // 2 1 12.967 13.204
    | "chatWhite"
    | "radio" // 0 0 19 19
    | "new" // 0 0 10 16
    | "filter" // 0 0 16 16
    | "attach" // 0 0 13 13
    | "sort" // 0 0 14.637 16.348
    | "toggle" // 0 0 20 20
    | "toggleActive" // 0 0 20 20
    | "chipDel" // 0 0 10 10
    | "search" // 0 0 24 24
    | "searchDel" // 0 0 24 24
    | "write" // 0 0 53 53
    | "selectArrow" // 0 0 15 9
    | "selectArrowSmall" // 0 0 24 24
    | "thumbDel" // 0 0 24 24
    | "trDel" // 0 0 20 20
    | "star" // 0 0 20 20
    | "bigStar" // 0 0 49 47
    | "bigStarActive" // 0 0 49 47
    | "warning" // 0 0 48 48
    | "error" // 0 0 230 230
    | "comingSoon" // 0 0 230 230
    | "pageLeft" // 0 0 40 40
    | "pageRight" // 0 0 40 40
    | "pageFirst" // 0 0 40 40
    | "pageLast" // 0 0 40 40
    | "datepicker" // 0 0 24 24
    | string;
  className?: string;
  xmlns?: string;
  width?: number;
  height?: number;
  viewBox?: string;
  version?: string;
  style?: React.CSSProperties;
};

export default function SVG({ name, className, xmlns, width, height, viewBox, version, style }: SVGType) {
  let data = null;
  switch (name) {
    case "alarmWhite":
      data = (
        <g id="그룹_4086" data-name="그룹 4086" transform="translate(-236 -249)">
          <rect id="Boundary" width="28" height="28" transform="translate(236 249)" fill="none" />
          <g id="_Color" data-name=" ↳Color" transform="translate(240.376 251)" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path
              d="M9.624,24a2.437,2.437,0,0,1-2.407-2.461h4.812A2.436,2.436,0,0,1,9.624,24Zm9.624-3.692H0l2.405-3.692V10.461a8.879,8.879,0,0,1,1.412-5,6.642,6.642,0,0,1,4-2.782V1.846a1.8,1.8,0,1,1,3.609,0v.837a6.65,6.65,0,0,1,4,2.787,8.868,8.868,0,0,1,1.417,4.992v6.154l2.405,3.69Z"
              stroke="none"
            />
            <path
              d="M 9.623897552490234 24 C 10.94970798492432 24 12.02932834625244 22.89653015136719 12.02932834625244 21.5389404296875 L 7.21737813949585 21.5389404296875 C 7.21737813949585 22.89598083496094 8.296937942504883 24 9.623897552490234 24 M 19.24777793884277 20.30785942077637 L 16.84127807617188 16.61572074890137 L 16.84127807617188 10.4614200592041 C 16.84127807617188 8.568240165710449 16.3514575958252 6.841959953308105 15.42476844787598 5.469220161437988 C 14.46666812896729 4.049960136413574 13.0843677520752 3.08597993850708 11.42823791503906 2.682670116424561 L 11.42823791503906 1.846070051193237 C 11.42823791503906 0.8281499743461609 10.61881828308105 -1.77635683940025e-15 9.623897552490234 -1.77635683940025e-15 C 8.62897777557373 -1.77635683940025e-15 7.8195481300354 0.8281499743461609 7.8195481300354 1.846070051193237 L 7.8195481300354 2.682670116424561 C 6.157547950744629 3.085880041122437 4.773697853088379 4.047880172729492 3.817618131637573 5.46465015411377 C 2.893758058547974 6.833670139312744 2.40543794631958 8.561530113220215 2.40543794631958 10.4614200592041 L 2.40543794631958 16.61572074890137 L -1.984253003683989e-06 20.30785942077637 L 19.24777793884277 20.30785942077637 M 9.623897552490234 25.5 C 7.558977127075195 25.5 5.86310338973999 23.8670597076416 5.726283073425293 21.80785942077637 L -1.984253003683989e-06 21.80785942077637 C -0.5503519773483276 21.80785942077637 -1.056501984596252 21.50647926330566 -1.318751931190491 21.02263069152832 C -1.581001996994019 20.53878021240234 -1.557222008705139 19.95017051696777 -1.256801962852478 19.48904991149902 L 0.9054380059242249 16.17020034790039 L 0.9054380059242249 10.4614200592041 C 0.9054380059242249 8.261380195617676 1.482508063316345 6.243380069732666 2.574248075485229 4.625579833984375 C 3.517484426498413 3.227843284606934 4.801319122314453 2.192200660705566 6.329464912414551 1.585545778274536 C 6.461103439331055 -0.1382695138454437 7.888397216796875 -1.5 9.623897552490234 -1.5 C 11.35984325408936 -1.5 12.78742408752441 -0.1374564319849014 12.91843128204346 1.586986303329468 C 14.44173717498779 2.194338083267212 15.72356796264648 3.23094367980957 16.66799736022949 4.629950046539307 C 17.76266860961914 6.251520156860352 18.34127807617188 8.268010139465332 18.34127807617188 10.4614200592041 L 18.34127807617188 16.1700325012207 L 20.5031681060791 19.48687934875488 C 20.80370712280273 19.9479808807373 20.82819747924805 20.5376091003418 20.56597709655762 21.02153015136719 C 20.30374717712402 21.50546073913574 19.79817771911621 21.80785942077637 19.24777793884277 21.80785942077637 L 13.52042579650879 21.80785942077637 C 13.38364315032959 23.8670597076416 11.6882438659668 25.5 9.623897552490234 25.5 Z"
              stroke="none"
              fill="#fff"
            />
          </g>
        </g>
      );
      break;
    case "fileDownload":
      data = (
        <>
          <rect width="20" height="20" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99219 2.07617C10.4064 2.07617 10.7422 2.41196 10.7422 2.82617V13.4613C10.7422 13.8755 10.4064 14.2113 9.99219 14.2113C9.57797 14.2113 9.24219 13.8755 9.24219 13.4613V2.82617C9.24219 2.41196 9.57797 2.07617 9.99219 2.07617Z"
            fill="#626A6F"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 12.71C3.41421 12.71 3.75 13.0457 3.75 13.46V16.4234H16.25V13.46C16.25 13.0457 16.5858 12.71 17 12.71C17.4142 12.71 17.75 13.0457 17.75 13.46V17.1734C17.75 17.5877 17.4142 17.9234 17 17.9234H3C2.58579 17.9234 2.25 17.5877 2.25 17.1734V13.46C2.25 13.0457 2.58579 12.71 3 12.71Z"
            fill="#626A6F"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.32123 9.13862C5.61413 8.84572 6.089 8.84572 6.38189 9.13862L9.99986 12.7566L13.563 9.19346C13.8559 8.90056 14.3307 8.90056 14.6236 9.19346C14.9165 9.48635 14.9165 9.96122 14.6236 10.2541L10.5302 14.3476C10.3895 14.4882 10.1988 14.5672 9.99986 14.5672C9.80094 14.5672 9.61018 14.4882 9.46953 14.3476L5.32123 10.1993C5.02834 9.90638 5.02834 9.43151 5.32123 9.13862Z"
            fill="#626A6F"
          />
        </>
      );
      break;
    case "imgDownload":
      data = (
        <>
          <rect width="20" height="20" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99219 2.07617C10.4064 2.07617 10.7422 2.41196 10.7422 2.82617V13.4613C10.7422 13.8755 10.4064 14.2113 9.99219 14.2113C9.57797 14.2113 9.24219 13.8755 9.24219 13.4613V2.82617C9.24219 2.41196 9.57797 2.07617 9.99219 2.07617Z"
            fill="#000000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 12.71C3.41421 12.71 3.75 13.0457 3.75 13.46V16.4234H16.25V13.46C16.25 13.0457 16.5858 12.71 17 12.71C17.4142 12.71 17.75 13.0457 17.75 13.46V17.1734C17.75 17.5877 17.4142 17.9234 17 17.9234H3C2.58579 17.9234 2.25 17.5877 2.25 17.1734V13.46C2.25 13.0457 2.58579 12.71 3 12.71Z"
            fill="#000000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.32123 9.13862C5.61413 8.84572 6.089 8.84572 6.38189 9.13862L9.99986 12.7566L13.563 9.19346C13.8559 8.90056 14.3307 8.90056 14.6236 9.19346C14.9165 9.48635 14.9165 9.96122 14.6236 10.2541L10.5302 14.3476C10.3895 14.4882 10.1988 14.5672 9.99986 14.5672C9.80094 14.5672 9.61018 14.4882 9.46953 14.3476L5.32123 10.1993C5.02834 9.90638 5.02834 9.43151 5.32123 9.13862Z"
            fill="#000000"
          />
        </>
      );
      break;
    case "listView":
      data = (
        <>
          <rect width="24" height="24" fill="white" />
          <path d="M5.34813 4.57324H4.57422V5.35049H5.34813V4.57324Z" fill="#B9BEBE" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 4.57262C4 4.25637 4.25527 4 4.57017 4H5.34408C5.65897 4 5.91424 4.25637 5.91424 4.57262V5.34987C5.91424 5.66612 5.65897 5.92249 5.34408 5.92249H4.57017C4.25527 5.92249 4 5.66612 4 5.34987V4.57262Z"
            fill="#B9BEBE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.45703 4.96032C7.45703 4.64407 7.7123 4.3877 8.0272 4.3877H19.4305C19.7454 4.3877 20.0007 4.64407 20.0007 4.96032C20.0007 5.27657 19.7454 5.53294 19.4305 5.53294H8.0272C7.7123 5.53294 7.45703 5.27657 7.45703 4.96032Z"
            fill="#B9BEBE"
          />
          <path d="M5.34813 11.6104H4.57422V12.3876H5.34813V11.6104Z" fill="#B9BEBE" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 11.6097C4 11.2935 4.25527 11.0371 4.57017 11.0371H5.34408C5.65897 11.0371 5.91424 11.2935 5.91424 11.6097V12.387C5.91424 12.7032 5.65897 12.9596 5.34408 12.9596H4.57017C4.25527 12.9596 4 12.7032 4 12.387V11.6097Z"
            fill="#B9BEBE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.45703 11.9974C7.45703 11.6812 7.7123 11.4248 8.0272 11.4248H19.4305C19.7454 11.4248 20.0007 11.6812 20.0007 11.9974C20.0007 12.3137 19.7454 12.5701 19.4305 12.5701H8.0272C7.7123 12.5701 7.45703 12.3137 7.45703 11.9974Z"
            fill="#B9BEBE"
          />
          <path d="M5.34813 18.6514H4.57422V19.4286H5.34813V18.6514Z" fill="#B9BEBE" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 18.6507C4 18.3345 4.25527 18.0781 4.57017 18.0781H5.34408C5.65897 18.0781 5.91424 18.3345 5.91424 18.6507V19.428C5.91424 19.7442 5.65897 20.0006 5.34408 20.0006H4.57017C4.25527 20.0006 4 19.7442 4 19.428V18.6507Z"
            fill="#B9BEBE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.45703 19.0384C7.45703 18.7222 7.7123 18.4658 8.0272 18.4658H19.4305C19.7454 18.4658 20.0007 18.7222 20.0007 19.0384C20.0007 19.3547 19.7454 19.6111 19.4305 19.6111H8.0272C7.7123 19.6111 7.45703 19.3547 7.45703 19.0384Z"
            fill="#B9BEBE"
          />
        </>
      );
      break;
    case "listViewActive":
      data = (
        <>
          <rect width="24" height="24" fill="white" />
          <path d="M5.34813 4.57324H4.57422V5.35049H5.34813V4.57324Z" fill="black" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 4.57262C4 4.25637 4.25527 4 4.57017 4H5.34408C5.65897 4 5.91424 4.25637 5.91424 4.57262V5.34987C5.91424 5.66612 5.65897 5.92249 5.34408 5.92249H4.57017C4.25527 5.92249 4 5.66612 4 5.34987V4.57262Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.45703 4.96032C7.45703 4.64407 7.7123 4.3877 8.0272 4.3877H19.4305C19.7454 4.3877 20.0007 4.64407 20.0007 4.96032C20.0007 5.27657 19.7454 5.53294 19.4305 5.53294H8.0272C7.7123 5.53294 7.45703 5.27657 7.45703 4.96032Z"
            fill="black"
          />
          <path d="M5.34813 11.6104H4.57422V12.3876H5.34813V11.6104Z" fill="black" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 11.6097C4 11.2935 4.25527 11.0371 4.57017 11.0371H5.34408C5.65897 11.0371 5.91424 11.2935 5.91424 11.6097V12.387C5.91424 12.7032 5.65897 12.9596 5.34408 12.9596H4.57017C4.25527 12.9596 4 12.7032 4 12.387V11.6097Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.45703 11.9974C7.45703 11.6812 7.7123 11.4248 8.0272 11.4248H19.4305C19.7454 11.4248 20.0007 11.6812 20.0007 11.9974C20.0007 12.3137 19.7454 12.5701 19.4305 12.5701H8.0272C7.7123 12.5701 7.45703 12.3137 7.45703 11.9974Z"
            fill="black"
          />
          <path d="M5.34813 18.6514H4.57422V19.4286H5.34813V18.6514Z" fill="black" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 18.6507C4 18.3345 4.25527 18.0781 4.57017 18.0781H5.34408C5.65897 18.0781 5.91424 18.3345 5.91424 18.6507V19.428C5.91424 19.7442 5.65897 20.0006 5.34408 20.0006H4.57017C4.25527 20.0006 4 19.7442 4 19.428V18.6507Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.45703 19.0384C7.45703 18.7222 7.7123 18.4658 8.0272 18.4658H19.4305C19.7454 18.4658 20.0007 18.7222 20.0007 19.0384C20.0007 19.3547 19.7454 19.6111 19.4305 19.6111H8.0272C7.7123 19.6111 7.45703 19.3547 7.45703 19.0384Z"
            fill="black"
          />
        </>
      );
      break;
    case "gridView":
      data = (
        <>
          <rect width="24" height="24" fill="white" />
          <path d="M10.5211 4.5H4.5V10.5211H10.5211V4.5Z" stroke="#B9BEBE" strokeLinecap="round" strokeLinejoin="round" fill="white" />
          <path d="M19.5016 4.5H13.4805V10.5211H19.5016V4.5Z" stroke="#B9BEBE" strokeLinecap="round" strokeLinejoin="round" fill="white" />
          <path d="M10.5211 13.4795H4.5V19.5006H10.5211V13.4795Z" stroke="#B9BEBE" strokeLinecap="round" strokeLinejoin="round" fill="white" />
          <path d="M19.5016 13.4795H13.4805V19.5006H19.5016V13.4795Z" stroke="#B9BEBE" strokeLinecap="round" strokeLinejoin="round" fill="white" />
        </>
      );
      break;
    case "gridViewActive":
      data = (
        <>
          <rect width="24" height="24" fill="white" />
          <path d="M10.7072 4.5H4.5V10.7072H10.7072V4.5Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" fill="white" />
          <path d="M19.5001 4.5H13.293V10.7072H19.5001V4.5Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" fill="white" />
          <path d="M10.7072 13.2939H4.5V19.5011H10.7072V13.2939Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" fill="white" />
          <path d="M19.5001 13.2939H13.293V19.5011H19.5001V13.2939Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" fill="white" />
        </>
      );
      break;
    case "alarmBlack":
      data = (
        <g id="그룹_4089" data-name="그룹 4089" transform="translate(-633 -249)">
          <rect id="Boundary" width="28" height="28" transform="translate(633 249)" fill="none" />
          <g id="_Color" data-name=" ↳Color" transform="translate(637.376 251)" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path
              d="M9.624,24a2.437,2.437,0,0,1-2.407-2.461h4.812A2.436,2.436,0,0,1,9.624,24Zm9.624-3.692H0l2.405-3.692V10.461a8.879,8.879,0,0,1,1.412-5,6.642,6.642,0,0,1,4-2.782V1.846a1.8,1.8,0,1,1,3.609,0v.837a6.65,6.65,0,0,1,4,2.787,8.868,8.868,0,0,1,1.417,4.992v6.154l2.405,3.69Z"
              stroke="none"
            />
            <path
              d="M 9.623897552490234 24 C 10.94970798492432 24 12.02932834625244 22.89653015136719 12.02932834625244 21.5389404296875 L 7.21737813949585 21.5389404296875 C 7.21737813949585 22.89598083496094 8.296937942504883 24 9.623897552490234 24 M 19.24777793884277 20.30785942077637 L 16.84127807617188 16.61572074890137 L 16.84127807617188 10.4614200592041 C 16.84127807617188 8.568240165710449 16.3514575958252 6.841959953308105 15.42476844787598 5.469220161437988 C 14.46666812896729 4.049960136413574 13.0843677520752 3.08597993850708 11.42823791503906 2.682670116424561 L 11.42823791503906 1.846070051193237 C 11.42823791503906 0.8281499743461609 10.61881828308105 -1.77635683940025e-15 9.623897552490234 -1.77635683940025e-15 C 8.62897777557373 -1.77635683940025e-15 7.8195481300354 0.8281499743461609 7.8195481300354 1.846070051193237 L 7.8195481300354 2.682670116424561 C 6.157547950744629 3.085880041122437 4.773697853088379 4.047880172729492 3.817618131637573 5.46465015411377 C 2.893758058547974 6.833670139312744 2.40543794631958 8.561530113220215 2.40543794631958 10.4614200592041 L 2.40543794631958 16.61572074890137 L -1.984253003683989e-06 20.30785942077637 L 19.24777793884277 20.30785942077637 M 9.623897552490234 25.5 C 7.558977127075195 25.5 5.86310338973999 23.8670597076416 5.726283073425293 21.80785942077637 L -1.984253003683989e-06 21.80785942077637 C -0.5503519773483276 21.80785942077637 -1.056501984596252 21.50647926330566 -1.318751931190491 21.02263069152832 C -1.581001996994019 20.53878021240234 -1.557222008705139 19.95017051696777 -1.256801962852478 19.48904991149902 L 0.9054380059242249 16.17020034790039 L 0.9054380059242249 10.4614200592041 C 0.9054380059242249 8.261380195617676 1.482508063316345 6.243380069732666 2.574248075485229 4.625579833984375 C 3.517484426498413 3.227843284606934 4.801319122314453 2.192200660705566 6.329464912414551 1.585545778274536 C 6.461103439331055 -0.1382695138454437 7.888397216796875 -1.5 9.623897552490234 -1.5 C 11.35984325408936 -1.5 12.78742408752441 -0.1374564319849014 12.91843128204346 1.586986303329468 C 14.44173717498779 2.194338083267212 15.72356796264648 3.23094367980957 16.66799736022949 4.629950046539307 C 17.76266860961914 6.251520156860352 18.34127807617188 8.268010139465332 18.34127807617188 10.4614200592041 L 18.34127807617188 16.1700325012207 L 20.5031681060791 19.48687934875488 C 20.80370712280273 19.9479808807373 20.82819747924805 20.5376091003418 20.56597709655762 21.02153015136719 C 20.30374717712402 21.50546073913574 19.79817771911621 21.80785942077637 19.24777793884277 21.80785942077637 L 13.52042579650879 21.80785942077637 C 13.38364315032959 23.8670597076416 11.6882438659668 25.5 9.623897552490234 25.5 Z"
              stroke="none"
              fill="#000"
            />
          </g>
        </g>
      );
      break;
    case "userWhite":
      data = (
        <>
          <rect id="Boundary" width="28" height="28" fill="none" />
          <g id="그룹_3917" data-name="그룹 3917" transform="translate(-11918.477 3087.5)">
            <g id="그룹_3916" data-name="그룹 3916" transform="translate(11920 -3086)">
              <path
                id="패스_2906"
                data-name="패스 2906"
                d="M499.328,164.124v1.005H524.28v-1.005a12.488,12.488,0,0,0-12.476-12.5h0A12.488,12.488,0,0,0,499.328,164.124Z"
                transform="translate(-499.328 -140.129)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <line
                id="선_211"
                data-name="선 211"
                x2="7.397"
                y2="7.486"
                transform="translate(17.442 17.514)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <line
                id="선_212"
                data-name="선 212"
                x1="7.397"
                y2="7.486"
                transform="translate(0.112 17.514)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <circle
                id="타원_141"
                data-name="타원 141"
                cx="4.285"
                cy="4.285"
                r="4.285"
                transform="translate(7.755 0)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
            </g>
          </g>
        </>
      );
      break;
    case "userBlack":
      data = (
        <>
          <rect id="Boundary" width="28" height="28" fill="none" />
          <g id="그룹_3917" data-name="그룹 3917" transform="translate(-11918.477 3087.5)">
            <g id="그룹_3916" data-name="그룹 3916" transform="translate(11920 -3086)">
              <path
                id="패스_2906"
                data-name="패스 2906"
                d="M499.328,164.124v1.005H524.28v-1.005a12.488,12.488,0,0,0-12.476-12.5h0A12.488,12.488,0,0,0,499.328,164.124Z"
                transform="translate(-499.328 -140.129)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <line
                id="선_211"
                data-name="선 211"
                x2="7.397"
                y2="7.486"
                transform="translate(17.442 17.514)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <line
                id="선_212"
                data-name="선 212"
                x1="7.397"
                y2="7.486"
                transform="translate(0.112 17.514)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <circle
                id="타원_141"
                data-name="타원 141"
                cx="4.285"
                cy="4.285"
                r="4.285"
                transform="translate(7.755 0)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
            </g>
          </g>
        </>
      );
      break;
    case "setting":
      data = (
        <>
          <rect id="Boundary" width="28" height="28" fill="none" />
          <path
            id="_Color"
            data-name=" ↳Color"
            d="M13.865,25H9.134a.611.611,0,0,1-.592-.531L8.1,21.156a8.527,8.527,0,0,1-2-1.219L3.16,21.188a.615.615,0,0,1-.2.035.579.579,0,0,1-.519-.316L.07,16.579a.671.671,0,0,1,.149-.8l2.5-2.063A8.359,8.359,0,0,1,2.628,12.5a8.2,8.2,0,0,1,.1-1.219L.233,9.219a.627.627,0,0,1-.147-.8L2.451,4.093a.585.585,0,0,1,.514-.323.553.553,0,0,1,.21.042l2.943,1.25a8.808,8.808,0,0,1,2-1.219L8.558.531A.587.587,0,0,1,9.134,0h4.731a.6.6,0,0,1,.592.531L14.9,3.844a8.568,8.568,0,0,1,2,1.219l2.942-1.25a.615.615,0,0,1,.2-.035.579.579,0,0,1,.519.316l2.366,4.329a.67.67,0,0,1-.149.8l-2.5,2.063a8.218,8.218,0,0,1,.089,1.219,10.767,10.767,0,0,1-.074,1.219l2.47,2.063a.627.627,0,0,1,.147.8l-2.365,4.328a.585.585,0,0,1-.514.323.553.553,0,0,1-.21-.042l-2.943-1.25a8.725,8.725,0,0,1-2,1.219l-.444,3.313A.572.572,0,0,1,13.865,25ZM11.5,7.813A4.572,4.572,0,0,0,7.064,12.5,4.572,4.572,0,0,0,11.5,17.188,4.572,4.572,0,0,0,15.935,12.5,4.572,4.572,0,0,0,11.5,7.813Z"
            transform="translate(2.5 1.5)"
          />
        </>
      );
      break;
    case "more":
      data = (
        <>
          <rect id="Boundary" width="28" height="28" fill="none" />
          <path
            id="_Color"
            data-name=" ↳Color"
            d="M3,24a3,3,0,1,1,3-3A3,3,0,0,1,3,24Zm0-9a3,3,0,1,1,3-3A3,3,0,0,1,3,15ZM3,6A3,3,0,1,1,6,3,3,3,0,0,1,3,6Z"
            transform="translate(11 2)"
          />
        </>
      );
      break;
    case "pin":
      data = (
        <>
          <g clipPath="url(#clip0_6760_75005)">
            <path
              d="M18.0318 16.6201L19.051 15.286L19.8023 16.0373C20.1669 16.4019 20.7635 16.4019 21.1281 16.0373L23.7798 13.3856C24.1444 13.021 24.1444 12.4244 23.7798 12.0598L16.2668 4.5468C15.9022 4.18219 15.3055 4.18219 14.9409 4.5468L12.2893 7.19845C11.9247 7.56305 11.9247 8.15967 12.2893 8.52427L13.0406 9.27557L11.7065 10.2948C9.47744 9.87772 7.24287 10.4771 5.66017 12.0598C5.29556 12.4244 5.29556 13.021 5.66017 13.3856L9.63764 17.3631L6.76502 20.2357C6.74016 20.2606 6.72083 20.2854 6.70701 20.3158L5.82313 22.0836C5.68779 22.3515 5.97505 22.6388 6.24298 22.5034L8.01074 21.6196C8.04113 21.6057 8.06875 21.5836 8.09084 21.5616L10.9635 18.6889L14.9409 22.6664C15.3055 23.031 15.9022 23.031 16.2668 22.6664C17.8495 21.0837 18.4489 18.8491 18.0318 16.6201ZM7.71796 12.7918C9.01064 11.9576 10.6348 11.8416 12.118 12.3415L15.8801 9.4634L14.278 7.86136L15.6039 6.53553L21.791 12.7227L20.4652 14.0485L18.8632 12.4465L15.985 16.2085C16.4822 17.689 16.3662 19.3187 15.5348 20.6086L7.71796 12.7918Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_6760_75005">
              <rect width="15" height="20" fill="white" transform="translate(14.72 3) rotate(45)" />
            </clipPath>
          </defs>
        </>
      );
      break;
    case "pinActive":
      data = (
        <>
          <g clipPath="url(#clip0_6760_74987)">
            <path
              d="M17.0382 17.1503L19.967 13.5456L21.1328 14.7115C21.4989 15.0776 22.0925 15.0776 22.4586 14.7115L23.7844 13.3856C24.1505 13.0195 24.1505 12.4259 23.7844 12.0598L16.2714 4.5468C15.9053 4.18067 15.3117 4.18067 14.9456 4.5468L13.6198 5.87262C13.2536 6.23874 13.2536 6.83233 13.6198 7.19845L14.7856 8.36426L11.1809 11.293C9.21815 10.5761 7.06628 10.6583 5.6648 12.0598C5.29868 12.4259 5.29868 13.0195 5.6648 13.3856L9.42131 17.1421L6.5485 20.0149C6.51419 20.0493 6.48834 20.0911 6.47301 20.1371L5.81009 22.1259C5.72886 22.3696 5.96121 22.6025 6.20538 22.5211L8.19412 21.8582C8.24015 21.8429 8.28197 21.817 8.31629 21.7827L11.1891 18.9099L14.9456 22.6664C15.3117 23.0326 15.9053 23.0326 16.2714 22.6664C17.6852 21.2527 17.7474 19.0921 17.0382 17.1503V17.1503Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_6760_74987">
              <rect width="15" height="20" fill="white" transform="translate(14.7246 3) rotate(45)" />
            </clipPath>
          </defs>
        </>
      );
      break;
    case "information":
      data = (
        <>
          <rect id="Boundary" width="28" height="28" transform="translate(28 28) rotate(180)" fill="none" />
          <path
            id="_Color"
            data-name=" ↳Color"
            d="M11.988,24A12,12,0,1,1,24,12,12.008,12.008,0,0,1,11.988,24ZM12,2.4A9.6,9.6,0,1,0,21.6,12,9.611,9.611,0,0,0,12,2.4ZM13.2,18H10.8V15.6h2.4V18Zm0-4.8H10.8V6h2.4v7.2Z"
            transform="translate(26 26) rotate(180)"
          />
        </>
      );
      break;
    case "logout":
      data = (
        <>
          <rect id="사각형_2453" data-name="사각형 2453" width="28" height="28" fill="none" />
          <g id="그룹_4015" data-name="그룹 4015" transform="translate(-135.411 -42.41)">
            <path
              id="패스_2937"
              data-name="패스 2937"
              d="M22.749,16.376v4.682a1.693,1.693,0,0,1-1.692,1.692H2.442A1.693,1.693,0,0,1,.75,21.058V2.442A1.692,1.692,0,0,1,2.442.75H21.057a1.692,1.692,0,0,1,1.692,1.692v4.6"
              transform="translate(137.661 44.66)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="패스_2938"
              data-name="패스 2938"
              d="M28.746,11.547l4.9,4.9-4.9,4.9"
              transform="translate(124.921 40.062)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <line
              id="선_247"
              data-name="선 247"
              x2="10.684"
              transform="translate(147.534 56.511)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
        </>
      );
      break;
    case "back":
      data = (
        <>
          <defs>
            <clipPath id="clip-path">
              <rect id="사각형_2490" data-name="사각형 2490" width="28" height="28" transform="translate(-2)" fill="none" stroke="#000" strokeWidth="1" />
            </clipPath>
          </defs>
          <rect id="Boundary" width="28" height="28" fill="none" />
          <g id="구성_요소_114_7" data-name="구성 요소 114 – 7">
            <g id="그룹_4081" data-name="그룹 4081" transform="translate(2)" clipPath="url(#clip-path)">
              <path
                id="패스_2955"
                data-name="패스 2955"
                d="M11,21,1,11,11,1"
                transform="translate(0.038 3)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
            </g>
          </g>
        </>
      );
      break;
    case "checkbox":
      data = (
        <g id="Rectangle_2420" data-name="Rectangle 2420" fill="none" stroke="#c3c8c8" strokeWidth="1">
          <rect width="20" height="20" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="19" height="19" rx="1.5" fill="none" />
        </g>
      );
      break;
    case "checkboxActive":
      data = (
        <g id="Group_3945" data-name="Group 3945" transform="translate(-15 -480)">
          <g id="Rectangle_2420" data-name="Rectangle 2420" transform="translate(15 480)" fill="#00263E" stroke="#00263E" strokeWidth="1">
            <rect width="20" height="20" rx="2" stroke="none" />
            <rect x="0.5" y="0.5" width="19" height="19" rx="1.5" fill="none" />
          </g>
          <path id="Exclusion_1" data-name="Exclusion 1" d="M12,7H0V0H2V5H12V7Z" transform="translate(18.283 490.268) rotate(-45)" fill="#fff" />
        </g>
      );
      break;
    case "checkDisabled":
      data = (
        <g id="Group_3945" data-name="Group 3945" transform="translate(-15 -480)">
          <g id="Rectangle_2420" data-name="Rectangle 2420" transform="translate(15 480)" fill="#bbb" stroke="#bbb" strokeWidth="1">
            <rect width="20" height="20" rx="2" stroke="none" />
            <rect x="0.5" y="0.5" width="19" height="19" rx="1.5" fill="none" />
          </g>
          <path id="Exclusion_1" data-name="Exclusion 1" d="M12,7H0V0H2V5H12V7Z" transform="translate(18.283 490.268) rotate(-45)" fill="#fff" />
        </g>
      );
      break;
    case "roundCheckbox":
      data = (
        <>
          <rect id="Boundary" width="24" height="24" fill="none" />
          <g id="타원_152" data-name="타원 152" transform="translate(2 2)" fill="#fff" stroke="#c3c8c8" strokeWidth="1" opacity="0.5">
            <circle cx="10" cy="10" r="10" stroke="none" />
            <circle cx="10" cy="10" r="9.5" fill="none" />
          </g>
        </>
      );
      break;
    case "roundCheckboxActive":
      data = (
        <>
          <path
            d="M21.892 12.1035C21.892 17.2498 17.7201 21.4217 12.5738 21.4217C7.42751 21.4217 3.25562 17.2498 3.25562 12.1035C3.25562 6.95723 7.42751 2.78534 12.5738 2.78534C17.7201 2.78534 21.892 6.95723 21.892 12.1035Z"
            stroke="white"
          />
          <path
            d="M12.5738 21.3763C17.6949 21.3763 21.8465 17.2248 21.8465 12.1036C21.8465 6.98241 17.6949 2.83087 12.5738 2.83087C7.45257 2.83087 3.30103 6.98241 3.30103 12.1036C3.30103 17.2248 7.45257 21.3763 12.5738 21.3763Z"
            stroke="white"
          />
          <circle cx="12.574" cy="12.1035" r="10" fill="white" />
          <path
            d="M12.574 22.1035C10.5962 22.1035 8.66277 21.517 7.01828 20.4182C5.37378 19.3194 4.09206 17.7576 3.33518 15.9304C2.57831 14.1031 2.38027 12.0924 2.76613 10.1526C3.15198 8.21281 4.10439 6.43098 5.50291 5.03245C6.90144 3.63393 8.68326 2.68152 10.6231 2.29567C12.5629 1.90982 14.5736 2.10785 16.4008 2.86472C18.2281 3.6216 19.7899 4.90333 20.8887 6.54782C21.9875 8.19231 22.574 10.1257 22.574 12.1035C22.571 14.7548 21.5165 17.2966 19.6418 19.1713C17.7671 21.0461 15.2252 22.1006 12.574 22.1035ZM6.98398 10.6935L5.57398 12.1035L10.574 17.1035L19.574 8.10352L18.164 6.68352L10.574 14.2735L6.98398 10.6935Z"
            fill="#00263E"
          />
        </>
      );
      break;
    case "lineCheckboxActive":
      data = (
        <>
          <path
            d="M22.1434 12.67C22.1434 17.8163 17.9716 21.9882 12.8253 21.9882C7.67897 21.9882 3.50708 17.8163 3.50708 12.67C3.50708 7.52376 7.67897 3.35187 12.8253 3.35187C17.9716 3.35187 22.1434 7.52376 22.1434 12.67Z"
            stroke="white"
          />
          <path
            d="M12.8252 21.9428C17.9464 21.9428 22.0979 17.7913 22.0979 12.6701C22.0979 7.54891 17.9464 3.39737 12.8252 3.39737C7.70403 3.39737 3.55249 7.54891 3.55249 12.6701C3.55249 17.7913 7.70403 21.9428 12.8252 21.9428Z"
            stroke="white"
          />
          <circle cx="12.8253" cy="12.67" r="9.81818" fill="white" />
          <path
            d="M12.8252 21.42C11.0946 21.42 9.40289 20.9069 7.96396 19.9454C6.52503 18.9839 5.40352 17.6174 4.74125 16.0185C4.07899 14.4197 3.90571 12.6603 4.24333 10.963C4.58095 9.26567 5.41431 7.70657 6.63801 6.48286C7.86172 5.25915 9.42082 4.4258 11.1182 4.08818C12.8155 3.75056 14.5748 3.92384 16.1737 4.5861C17.7725 5.24837 19.1391 6.36988 20.1006 7.80881C21.062 9.24774 21.5752 10.9395 21.5752 12.67C21.5726 14.9899 20.6499 17.214 19.0095 18.8544C17.3692 20.4948 15.1451 21.4175 12.8252 21.42ZM7.93395 11.4363L6.7002 12.67L11.0752 17.045L18.9502 9.17005L17.7164 7.92755L11.0752 14.5688L7.93395 11.4363Z"
            fill="#3274F6"
          />
        </>
      );
      break;
    case "roundCheckDisabled":
      data = (
        <>
          <rect id="Boundary" width="24" height="24" fill="none" />
          <path
            id="_Color"
            data-name=" ↳Color"
            d="M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM4.41,8.59h0L3,10l5,5,9-9L15.59,4.58,8,12.17,4.41,8.59Z"
            transform="translate(2 2)"
            fill="#bbb"
          />
        </>
      );
      break;
    case "modalClose":
      data = (
        <>
          <g id="그룹_3690" data-name="그룹 3690" transform="translate(-288.628 -96.589)">
            <path
              id="패스_2892"
              data-name="패스 2892"
              d="M7188.629,100.589l16,16"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#626a6f"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <path
              id="패스_2893"
              data-name="패스 2893"
              d="M7204.628,100.589l-16,16"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#626a6f"
              strokeLinecap="round"
              strokeWidth="2"
            />
          </g>
          <rect id="Boundary" width="24" height="24" fill="none" />
        </>
      );
      break;
    case "imageModalClose":
      data = (
        <>
          <g id="그룹_3690" data-name="그룹 3690" transform="translate(-288.628 -96.589)">
            <path
              id="패스_2892"
              data-name="패스 2892"
              d="M7188.629,100.589l16,16"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#ffffff"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <path
              id="패스_2893"
              data-name="패스 2893"
              d="M7204.628,100.589l-16,16"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#ffffff"
              strokeLinecap="round"
              strokeWidth="2"
            />
          </g>
          <rect id="Boundary" width="24" height="24" fill="none" />
        </>
      );
      break;
    case "iconAs":
      data = (
        <g id="Alarm_Icon-A_S" data-name="Alarm Icon-A/S" transform="translate(-15 -127)">
          <circle id="Ellipse_111" data-name="Ellipse 111" cx="16" cy="16" r="16" transform="translate(15 127)" fill="rgba(3,101,255,0.2)" />
          <g id="Group_3671" data-name="Group 3671" transform="translate(-625.669 -247.416)">
            <path
              id="Path_2885"
              data-name="Path 2885"
              d="M663.023,399.463l7.771,7.834a1.962,1.962,0,0,0,2.778,0h0a1.962,1.962,0,0,0,0-2.771l-7.735-7.8"
              transform="translate(-7.477 -7.46)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <g id="Group_3670" data-name="Group 3670" transform="translate(646.669 380.416)">
              <path
                id="Path_2886"
                data-name="Path 2886"
                d="M652.75,380.416a6.131,6.131,0,0,0-1,.09l4.078,4.078-4.728,4.728-4.25-4.249a6.078,6.078,0,1,0,5.9-4.647Z"
                transform="translate(-646.669 -380.416)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
            </g>
          </g>
        </g>
      );
      break;
    case "iconComment":
      data = (
        <g id="Alarm_Icon-Chat" data-name="Alarm Icon-Chat" transform="translate(-15 -236)">
          <circle id="Ellipse_127" data-name="Ellipse 127" cx="16" cy="16" r="16" transform="translate(15 236)" fill="rgba(3,101,255,0.2)" />
          <g id="Group_3921" data-name="Group 3921" transform="translate(-475.763 16.742)">
            <path
              id="Path_2907"
              data-name="Path 2907"
              d="M513.358,246.258l-5.807-5.878H496.788V226.258h19.95v14.071h-3.38v5.929"
              transform="translate(0 0)"
              fill="rgba(0,0,0,0)"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <g id="Group_3918" data-name="Group 3918" transform="translate(500.063 231.856)">
              <circle id="Ellipse_143" data-name="Ellipse 143" cx="1.486" cy="1.486" r="1.486" transform="translate(0 0)" />
              <circle id="Ellipse_144" data-name="Ellipse 144" cx="1.486" cy="1.486" r="1.486" transform="translate(5.214 0)" />
              <circle id="Ellipse_145" data-name="Ellipse 145" cx="1.486" cy="1.486" r="1.486" transform="translate(10.428 0)" />
            </g>
          </g>
        </g>
      );
      break;
    case "iconNotice":
      data = (
        <>
          <circle cx="16" cy="16" r="16" fill="#CDDFFD" />
          <path
            d="M16.6735 19.6067L22.9019 25.0091V6.83824H20.1061L12.5354 13.3278H6.71924V16.5299L10.3259 19.6212H16.6727"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path d="M25.2809 9.18442V22.6637" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M11.3384 20.8611V25.1618" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </>
      );
      break;
    case "iconDoc":
      data = (
        <g id="Alarm_Icon-document" data-name="Alarm Icon-document" transform="translate(-15 -343)">
          <circle id="Ellipse_128" data-name="Ellipse 128" cx="16" cy="16" r="16" transform="translate(15 343)" fill="rgba(3,101,255,0.2)" />
          <g id="그룹_3642" data-name="그룹 3642" transform="translate(-154.236 214.662)">
            <path
              id="패스_2878"
              data-name="패스 2878"
              d="M194.816,154.305H180V140.3l5.9-5.959h8.917Z"
              transform="translate(-1.949 0)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <line
              id="선_59"
              data-name="선 59"
              x2="7.698"
              y2="7.791"
              transform="translate(185.17 146.546)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <line
              id="선_60"
              data-name="선 60"
              x1="4.607"
              y2="4.662"
              transform="translate(175.749 134.338)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="패스_2879"
              data-name="패스 2879"
              d="M175.749,143.6v14.816"
              transform="translate(0 -4.077)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
        </g>
      );
      break;
    case "switch":
      data = (
        <>
          <g clipPath="url(#clip0_5403_69907)">
            <path
              d="M38 0.676758H12C5.37258 0.676758 0 6.04934 0 12.6768C0 19.3042 5.37258 24.6768 12 24.6768H38C44.6274 24.6768 50 19.3042 50 12.6768C50 6.04934 44.6274 0.676758 38 0.676758Z"
              fill="#00263E"
              fillOpacity="0.3"
            />
            <path
              d="M13 21.6768C17.9706 21.6768 22 17.6473 22 12.6768C22 7.70619 17.9706 3.67676 13 3.67676C8.02944 3.67676 4 7.70619 4 12.6768C4 17.6473 8.02944 21.6768 13 21.6768Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5403_69907">
              <rect width="50" height="24" fill="white" transform="translate(0 0.676758)" />
            </clipPath>
          </defs>
        </>
      );
      break;
    case "switchActive":
      data = (
        <>
          <g clipPath="url(#clip0_5403_69926)">
            <path
              d="M38 0.854492H12C5.37258 0.854492 0 6.22708 0 12.8545C0 19.4819 5.37258 24.8545 12 24.8545H38C44.6274 24.8545 50 19.4819 50 12.8545C50 6.22708 44.6274 0.854492 38 0.854492Z"
              fill="#00263E"
            />
            <path
              d="M36 21.8545C40.9706 21.8545 45 17.8251 45 12.8545C45 7.88393 40.9706 3.85449 36 3.85449C31.0294 3.85449 27 7.88393 27 12.8545C27 17.8251 31.0294 21.8545 36 21.8545Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5403_69926">
              <rect width="50" height="24" fill="white" transform="translate(0 0.854492)" />
            </clipPath>
          </defs>
        </>
      );
      break;
    case "chat":
      data = (
        <>
          <g id="그룹_4144" data-name="그룹 4144" transform="translate(-496.288 -225.758)">
            <path
              id="패스_2907"
              data-name="패스 2907"
              d="M506.728,238.255l-3.484-3.526h-6.456v-8.472h11.967V234.7h-2.027v3.557"
              transform="translate(0)"
              fill="none"
              stroke="#3c3c3c"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.7"
            />
            <g id="그룹_3918" data-name="그룹 3918" transform="translate(498.675 229.604)" opacity="0.7">
              <circle id="타원_143" data-name="타원 143" cx="0.909" cy="0.909" r="0.909" transform="translate(0 0)" fill="#3c3c3c" />
              <circle id="타원_144" data-name="타원 144" cx="0.909" cy="0.909" r="0.909" transform="translate(3.188 0)" fill="#3c3c3c" />
              <circle id="타원_145" data-name="타원 145" cx="0.909" cy="0.909" r="0.909" transform="translate(6.377 0)" fill="#3c3c3c" />
            </g>
          </g>
        </>
      );
      break;
    case "chatActive":
      data = (
        <>
          <g clipPath="url(#clip0_5418_69255)">
            <path d="M9.94 12.497L6.45599 8.97102H0V0.499023H11.967V8.94202H9.94V12.499" fill="#146EAA" />
            <path
              d="M2.79599 5.66407C3.29802 5.66407 3.70499 5.2571 3.70499 4.75507C3.70499 4.25304 3.29802 3.84607 2.79599 3.84607C2.29397 3.84607 1.88699 4.25304 1.88699 4.75507C1.88699 5.2571 2.29397 5.66407 2.79599 5.66407Z"
              fill="white"
            />
            <path
              d="M5.98398 5.66407C6.48601 5.66407 6.89298 5.2571 6.89298 4.75507C6.89298 4.25304 6.48601 3.84607 5.98398 3.84607C5.48195 3.84607 5.07498 4.25304 5.07498 4.75507C5.07498 5.2571 5.48195 5.66407 5.98398 5.66407Z"
              fill="white"
            />
            <path
              d="M9.17301 5.66407C9.67503 5.66407 10.082 5.2571 10.082 4.75507C10.082 4.25304 9.67503 3.84607 9.17301 3.84607C8.67098 3.84607 8.26401 4.25304 8.26401 4.75507C8.26401 5.2571 8.67098 5.66407 9.17301 5.66407Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5418_69255">
              <rect width="11.967" height="11.997" fill="white" transform="translate(0 0.5)" />
            </clipPath>
          </defs>
        </>
      );
      break;
    case "chatWhite":
      data = (
        <>
          <g clipPath="url(#clip0_5304_76478)">
            <path d="M9.94 12.1206L6.45599 8.59456H0V0.122559H11.967V8.56555H9.94V12.1226" fill="#E7E9EF" />
            <path
              d="M2.79621 5.28773C3.29823 5.28773 3.70521 4.88075 3.70521 4.37873C3.70521 3.8767 3.29823 3.46973 2.79621 3.46973C2.29418 3.46973 1.88721 3.8767 1.88721 4.37873C1.88721 4.88075 2.29418 5.28773 2.79621 5.28773Z"
              fill="#00263E"
            />
            <path
              d="M5.9842 5.28773C6.48622 5.28773 6.8932 4.88075 6.8932 4.37873C6.8932 3.8767 6.48622 3.46973 5.9842 3.46973C5.48217 3.46973 5.0752 3.8767 5.0752 4.37873C5.0752 4.88075 5.48217 5.28773 5.9842 5.28773Z"
              fill="#00263E"
            />
            <path
              d="M9.17316 5.28773C9.67519 5.28773 10.0822 4.88075 10.0822 4.37873C10.0822 3.8767 9.67519 3.46973 9.17316 3.46973C8.67113 3.46973 8.26416 3.8767 8.26416 4.37873C8.26416 4.88075 8.67113 5.28773 9.17316 5.28773Z"
              fill="#00263E"
            />
          </g>
          <defs>
            <clipPath id="clip0_5304_76478">
              <rect width="11.967" height="11.997" fill="white" transform="translate(0 0.123535)" />
            </clipPath>
          </defs>
        </>
      );
      break;
    case "radio":
      data = (
        <>
          <path
            d="M9.48103 18.1245C7.72189 18.1245 6.00226 17.6036 4.53959 16.6277C3.07692 15.6518 1.93691 14.2646 1.26372 12.6417C0.590524 11.0188 0.414386 9.23306 0.757576 7.5102C1.10077 5.78734 1.94787 4.2048 3.19177 2.96269C4.43567 1.72058 6.02049 0.874687 7.74582 0.531989C9.47116 0.189291 11.2595 0.365176 12.8847 1.0374C14.51 1.70963 15.8991 2.848 16.8764 4.30857C17.8537 5.76914 18.3754 7.4863 18.3754 9.24291C18.3728 11.5977 17.4348 13.8552 15.7674 15.5203C14.0999 17.1853 11.8392 18.1219 9.48103 18.1245ZM4.50908 7.99061L3.25498 9.24291L7.70216 13.6837L15.7071 5.69028L14.453 4.4291L7.70216 11.1702L4.50908 7.99061Z"
            fill="#00263E"
          />
        </>
      );
      break;
    case "new":
      data = (
        <text id="N" transform="translate(0 13)" fill="#f55555" fontSize="14" fontFamily="Roboto-Bold, Roboto" fontWeight="700">
          <tspan x="0" y="0">
            N
          </tspan>
        </text>
      );
      break;
    case "filter":
      data = (
        <>
          <g id="Group_3677" data-name="Group 3677" transform="translate(-279.403 -225.019)">
            <g id="Group_3674" data-name="Group 3674" transform="translate(281.027 227.269)">
              <line
                id="Line_88"
                data-name="Line 88"
                x2="1.65"
                transform="translate(11.101 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <line
                id="Line_89"
                data-name="Line 89"
                x2="8.043"
                transform="translate(0 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <circle
                id="Ellipse_90"
                data-name="Ellipse 90"
                cx="1.499"
                cy="1.499"
                r="1.499"
                transform="translate(8.102)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </g>
            <g id="Group_3675" data-name="Group 3675" transform="translate(281.027 235.77)">
              <line
                id="Line_90"
                data-name="Line 90"
                x2="1.65"
                transform="translate(11.101 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <line
                id="Line_91"
                data-name="Line 91"
                x2="8.043"
                transform="translate(0 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <circle
                id="Ellipse_91"
                data-name="Ellipse 91"
                cx="1.499"
                cy="1.499"
                r="1.499"
                transform="translate(8.102)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </g>
            <g id="Group_3676" data-name="Group 3676" transform="translate(281.027 231.52)">
              <line
                id="Line_92"
                data-name="Line 92"
                x1="1.65"
                transform="translate(0 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <line
                id="Line_93"
                data-name="Line 93"
                x1="8.043"
                transform="translate(4.707 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <circle
                id="Ellipse_92"
                data-name="Ellipse 92"
                cx="1.499"
                cy="1.499"
                r="1.499"
                transform="translate(1.65)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </g>
          </g>
          <rect id="Rectangle_2482" data-name="Rectangle 2482" width="16" height="16" fill="none" />
        </>
      );
      break;
    case "filter":
      data = (
        <>
          <g id="Group_3677" data-name="Group 3677" transform="translate(-279.403 -225.019)">
            <g id="Group_3674" data-name="Group 3674" transform="translate(281.027 227.269)">
              <line
                id="Line_88"
                data-name="Line 88"
                x2="1.65"
                transform="translate(11.101 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <line
                id="Line_89"
                data-name="Line 89"
                x2="8.043"
                transform="translate(0 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <circle
                id="Ellipse_90"
                data-name="Ellipse 90"
                cx="1.499"
                cy="1.499"
                r="1.499"
                transform="translate(8.102)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </g>
            <g id="Group_3675" data-name="Group 3675" transform="translate(281.027 235.77)">
              <line
                id="Line_90"
                data-name="Line 90"
                x2="1.65"
                transform="translate(11.101 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <line
                id="Line_91"
                data-name="Line 91"
                x2="8.043"
                transform="translate(0 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <circle
                id="Ellipse_91"
                data-name="Ellipse 91"
                cx="1.499"
                cy="1.499"
                r="1.499"
                transform="translate(8.102)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </g>
            <g id="Group_3676" data-name="Group 3676" transform="translate(281.027 231.52)">
              <line
                id="Line_92"
                data-name="Line 92"
                x1="1.65"
                transform="translate(0 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <line
                id="Line_93"
                data-name="Line 93"
                x1="8.043"
                transform="translate(4.707 1.47)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <circle
                id="Ellipse_92"
                data-name="Ellipse 92"
                cx="1.499"
                cy="1.499"
                r="1.499"
                transform="translate(1.65)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </g>
          </g>
          <rect id="Rectangle_2482" data-name="Rectangle 2482" width="16" height="16" fill="none" />
        </>
      );
      break;
    case "attach":
      data = (
        <>
          <g clipPath="url(#clip0_573_699)">
            <path
              d="M1.71407 11.8947C0.241284 10.4217 0.241005 8.03732 1.71407 6.56408L7.42724 0.850173C8.56075 -0.283391 10.405 -0.283391 11.5385 0.850173C12.6745 1.98638 12.6748 3.8256 11.5385 4.96203L6.72785 9.7733C5.93033 10.5709 4.63267 10.5709 3.8352 9.77333C3.03593 8.97398 3.03565 7.67979 3.8352 6.88022L7.90943 2.80543C8.02844 2.68642 8.22138 2.68642 8.34036 2.80543L8.77116 3.23633C8.89012 3.35531 8.89012 3.54821 8.77116 3.66719L4.69683 7.74203C4.37376 8.0651 4.37361 8.58825 4.69683 8.91147C5.01919 9.23385 5.54376 9.2339 5.86617 8.91144L10.6768 4.1002C11.3366 3.44032 11.3368 2.37211 10.6768 1.71206C10.0184 1.05358 8.94725 1.05363 8.28887 1.71206L2.57572 7.42594C1.57917 8.42257 1.57894 10.036 2.5757 11.0329C3.57317 12.0305 5.18801 12.0304 6.18528 11.0321C7.84291 9.37292 9.50085 7.71401 11.1591 6.0554C11.2781 5.9364 11.4709 5.93647 11.59 6.05551L12.0208 6.48641C12.1397 6.60539 12.1398 6.79818 12.0209 6.91716C10.3627 8.57568 8.70486 10.2345 7.04732 11.8936C5.5738 13.3686 3.18784 13.3686 1.71407 11.8947V11.8947Z"
              fill="#626A6F"
            />
          </g>
          <defs>
            <clipPath id="clip0_573_699">
              <rect width="13" height="13" fill="white" />
            </clipPath>
          </defs>
        </>
      );
      break;
    case "chipDel":
      data = (
        <g id="Group_3694" data-name="Group 3694" transform="translate(-291.568 -99.528)">
          <path
            id="Path_2892"
            data-name="Path 2892"
            d="M7188.628,100.589l8,8"
            transform="translate(-6896)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            id="Path_2893"
            data-name="Path 2893"
            d="M7196.628,100.589l-8,8"
            transform="translate(-6896)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
        </g>
      );
      break;
    case "sort":
      data = (
        <>
          <defs>
            <clipPath id="clip-path">
              <rect
                id="사각형_2650"
                data-name="사각형 2650"
                width="14.637"
                height="16.348"
                transform="translate(-1 -2)"
                fill="none"
                stroke="#626a6f"
                strokeWidth="1"
              />
            </clipPath>
          </defs>
          <g id="그룹_4250" data-name="그룹 4250" transform="translate(1 2)">
            <g id="그룹_4249" data-name="그룹 4249" transform="translate(0 0)" clipPath="url(#clip-path)">
              <path
                id="패스_2994"
                data-name="패스 2994"
                d="M6.487,15.517,3.618,18.385.75,15.517"
                transform="translate(-0.313 -6.475)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <line
                id="선_356"
                data-name="선 356"
                y2="11.474"
                transform="translate(3.305 0.437)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="패스_2995"
                data-name="패스 2995"
                d="M16.828,3.619,13.96.75,11.091,3.619"
                transform="translate(-4.628 -0.313)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <line
                id="선_357"
                data-name="선 357"
                y1="11.474"
                transform="translate(9.331 0.437)"
                fill="none"
                stroke="#626a6f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </g>
          </g>
        </>
      );
      break;
    case "toggle":
      data = (
        <>
          <defs>
            <clipPath id="clip-path">
              <rect id="사각형_2654" data-name="사각형 2654" width="16" height="16" fill="none" stroke="#fff" strokeWidth="1" />
            </clipPath>
          </defs>
          <g id="마스크_그룹_13" data-name="마스크 그룹 13" clipPath="url(#clip-path)">
            <path
              id="패스_2998"
              data-name="패스 2998"
              d="M.75,6.369,4.165,9.825,13.133.75"
              fill="none"
              stroke="#626a6f"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </g>
        </>
      );
      break;
    case "toggleActive":
      data = (
        <>
          <defs>
            <clipPath id="clip-path">
              <rect id="사각형_2653" data-name="사각형 2653" width="16" height="16" fill="none" stroke="#fff" strokeWidth="1" />
            </clipPath>
          </defs>
          <g id="마스크_그룹_12" data-name="마스크 그룹 12" clipPath="url(#clip-path)">
            <path
              id="패스_2997"
              data-name="패스 2997"
              d="M.75,6.369,4.165,9.825,13.133.75"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </g>
        </>
      );
      break;
    case "camera":
      data = (
        <>
          <defs>
            <clipPath id="clip-path">
              <rect id="사각형_2494" data-name="사각형 2494" width="28" height="24.791" fill="none" stroke="#707070" strokeWidth="2" />
            </clipPath>
          </defs>
          <rect id="사각형_2495" data-name="사각형 2495" width="28" height="28" fill="none" />
          <g id="그룹_4083" data-name="그룹 4083" transform="translate(3 3.604)">
            <g id="그룹_4082" data-name="그룹 4082" transform="translate(-3 -2)" clipPath="url(#clip-path)">
              <path
                id="패스_2956"
                data-name="패스 2956"
                d="M20.754,16.15a4.793,4.793,0,1,1-4.793-4.793A4.793,4.793,0,0,1,20.754,16.15Z"
                transform="translate(-2.091 -2.606)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="패스_2957"
                data-name="패스 2957"
                d="M21.677,4.351H18.41a.871.871,0,0,1-.73-.4L15.847,1.145A.871.871,0,0,0,15.118.75H8.779a.871.871,0,0,0-.729.395L6.218,3.956a.873.873,0,0,1-.73.4H2.47A1.721,1.721,0,0,0,.75,6.072V19.329A1.759,1.759,0,0,0,2.5,21.083h19.16a1.744,1.744,0,0,0,1.744-1.744V6.081A1.735,1.735,0,0,0,21.677,4.351Z"
                transform="translate(1.922 1.479)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </g>
          </g>
        </>
      );
      break;
    case "send":
      data = (
        <>
          <defs>
            <clipPath id="clip-path">
              <rect id="사각형_2496" data-name="사각형 2496" width="28" height="28" transform="translate(0 0)" fill="none" stroke="#707070" strokeWidth="2" />
            </clipPath>
          </defs>
          <rect id="사각형_2497" data-name="사각형 2497" width="28" height="28" transform="translate(0 0)" fill="none" />
          <g id="그룹_4085" data-name="그룹 4085" transform="translate(1 3)">
            <g id="그룹_4084" data-name="그룹 4084" transform="translate(-1 -3)" clipPath="url(#clip-path)">
              <path
                id="패스_2958"
                data-name="패스 2958"
                d="M27.9.75,13.824,14.829l4.2,9.145Z"
                transform="translate(-2.29 1.638)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="패스_2959"
                data-name="패스 2959"
                d="M23.973.75,9.895,14.829.75,10.63Z"
                transform="translate(1.639 1.638)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </g>
          </g>
        </>
      );
      break;
    case "expand":
      data = (
        <>
          <defs>
            <filter id="타원_83" x="0" y="0" width="58" height="58" filterUnits="userSpaceOnUse">
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feFlood floodColor="#626a6f" floodOpacity="0.2" />
              <feComposite operator="in" in2="blur" />
              <feComposite in="SourceGraphic" />
            </filter>
            <clipPath id="clip-path">
              <rect
                id="사각형_2578"
                data-name="사각형 2578"
                width="24"
                height="24"
                transform="translate(0 -0.592)"
                fill="none"
                stroke="#00263E"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </clipPath>
          </defs>
          <g id="그룹_4179" data-name="그룹 4179" transform="translate(-194 -807)">
            <g transform="matrix(1, 0, 0, 1, 194, 807)" filter="url(#타원_83)">
              <circle id="타원_83-2" data-name="타원 83" cx="20" cy="20" r="20" transform="translate(9 7)" fill="#fff" />
            </g>
            <g id="그룹_4153" data-name="그룹 4153" transform="translate(211 822.592)" clipPath="url(#clip-path)">
              <g id="그룹_4177" data-name="그룹 4177" transform="translate(21.645 9.109) rotate(180)">
                <g id="그룹_4175" data-name="그룹 4175" transform="translate(0 0)">
                  <path
                    id="패스_2986"
                    data-name="패스 2986"
                    d="M0,0V7.347H7.372"
                    fill="none"
                    stroke="#00263E"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  />
                </g>
                <line
                  id="선_314"
                  data-name="선 314"
                  x1="7.372"
                  y2="7.347"
                  transform="translate(0 0)"
                  fill="none"
                  stroke="#00263E"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
              </g>
              <g id="그룹_4176" data-name="그룹 4176" transform="translate(9.728 21.054) rotate(180)">
                <path
                  id="패스_2987"
                  data-name="패스 2987"
                  d="M7.372,7.347V0H0"
                  transform="translate(0 0)"
                  fill="none"
                  stroke="#00263E"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <line
                  id="선_315"
                  data-name="선 315"
                  y1="7.347"
                  x2="7.372"
                  transform="translate(0)"
                  fill="none"
                  stroke="#00263E"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
              </g>
            </g>
          </g>
        </>
      );
      break;
    case "reduce":
      data = (
        <>
          <defs>
            <filter id="타원_204" x="0" y="0" width="58" height="58" filterUnits="userSpaceOnUse">
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feFlood floodColor="#626a6f" floodOpacity="0.2" />
              <feComposite operator="in" in2="blur" />
              <feComposite in="SourceGraphic" />
            </filter>
            <clipPath id="clip-path">
              <rect
                id="사각형_2578"
                data-name="사각형 2578"
                width="24"
                height="24"
                transform="translate(0 0.408)"
                fill="none"
                stroke="#00263E"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </clipPath>
          </defs>
          <g id="그룹_4178" data-name="그룹 4178" transform="translate(-242 -810)">
            <g transform="matrix(1, 0, 0, 1, 242, 810)" filter="url(#타원_204)">
              <circle id="타원_204-2" data-name="타원 204" cx="20" cy="20" r="20" transform="translate(9 7)" fill="#fff" />
            </g>
            <g id="그룹_4156" data-name="그룹 4156" transform="translate(262 826.592)">
              <g id="그룹_4153" data-name="그룹 4153" transform="translate(-3 -2)" clipPath="url(#clip-path)">
                <path
                  id="패스_2986"
                  data-name="패스 2986"
                  d="M23.258.75V8.4h7.679"
                  transform="translate(-8.686 1.406)"
                  fill="none"
                  stroke="#00263E"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <line
                  id="선_314"
                  data-name="선 314"
                  x1="7.679"
                  y2="7.654"
                  transform="translate(14.572 2.156)"
                  fill="none"
                  stroke="#00263E"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <path
                  id="패스_2987"
                  data-name="패스 2987"
                  d="M8.429,31.04V23.386H.75"
                  transform="translate(1.407 -8.787)"
                  fill="none"
                  stroke="#00263E"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <line
                  id="선_315"
                  data-name="선 315"
                  y1="7.654"
                  x2="7.679"
                  transform="translate(2.157 14.599)"
                  fill="none"
                  stroke="#00263E"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
              </g>
            </g>
          </g>
        </>
      );
      break;
    case "search":
      data = (
        <>
          <path
            id="패스_2883"
            data-name="패스 2883"
            d="M622.545,399.845l-5.959-6.032-3.392-3.392-.05-.048a6.218,6.218,0,1,1,1.737-4.311"
            transform="translate(-600.946 -377.346)"
            fill="none"
            stroke="#00263e"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <rect id="Boundary" width="24" height="24" fill="none" />
        </>
      );
      break;
    case "searchDel":
      data = (
        <>
          <g id="타원_93" data-name="타원 93" fill="#60677d" stroke="#626a6f" strokeWidth="1">
            <circle cx="12" cy="12" r="12" stroke="none" />
            <circle cx="12" cy="12" r="11.5" fill="none" />
          </g>
          <g id="그룹_3690" data-name="그룹 3690" transform="translate(-284.629 -92.589)">
            <path
              id="패스_2892"
              data-name="패스 2892"
              d="M7188.628,100.589l8,8"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
            <path
              id="패스_2893"
              data-name="패스 2893"
              d="M7196.628,100.589l-8,8"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
        </>
      );
      break;
    case "keywordDel":
      data = (
        <>
          <g id="그룹_3690" data-name="그룹 3690" transform="translate(-288.628 -96.589)">
            <path
              id="패스_2892"
              data-name="패스 2892"
              d="M7188.629,100.589l12,12"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#626a6f"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
            <path
              id="패스_2893"
              data-name="패스 2893"
              d="M7200.628,100.589l-12,12"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#626a6f"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
          <rect id="Boundary" width="20" height="20" fill="none" />
        </>
      );
      break;
    case "write":
      data = (
        <>
          <g clipPath="url(#clip0_5194_65457)">
            <path
              d="M26.9839 52.6035C41.3433 52.6035 52.9839 40.9629 52.9839 26.6035C52.9839 12.2441 41.3433 0.603516 26.9839 0.603516C12.6245 0.603516 0.983887 12.2441 0.983887 26.6035C0.983887 40.9629 12.6245 52.6035 26.9839 52.6035Z"
              fill="#00263E"
            />
            <path
              d="M25.1739 15.0635V24.7945H15.4429C14.9442 24.801 14.4677 25.002 14.1151 25.3547C13.7624 25.7074 13.5614 26.1838 13.5549 26.6825C13.5872 27.1731 13.7963 27.6354 14.1435 27.9835C14.4907 28.3316 14.9524 28.542 15.4429 28.5755H25.1739V38.1485C25.1804 38.6473 25.3814 39.1237 25.7341 39.4764C26.0868 39.8291 26.5632 40.0301 27.0619 40.0365C27.5532 40.0042 28.0159 39.7945 28.3642 39.4464C28.7124 39.0984 28.9223 38.6358 28.9549 38.1445V28.5755H38.5279C39.0266 28.5691 39.5031 28.3681 39.8558 28.0154C40.2085 27.6627 40.4095 27.1863 40.4159 26.6875C40.4305 26.4489 40.3969 26.2098 40.3171 25.9845C40.2372 25.7592 40.1128 25.5522 39.9513 25.376C39.7897 25.1998 39.5943 25.058 39.3768 24.9589C39.1592 24.8599 38.9239 24.8057 38.6849 24.7995H29.1079V15.0635C29.1014 14.5647 28.9003 14.088 28.5474 13.7353C28.1945 13.3826 27.7178 13.1818 27.2189 13.1755C26.7118 13.2037 26.2303 13.4075 25.8571 13.752C25.484 14.0966 25.2424 14.5603 25.1739 15.0635Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5194_65457">
              <rect width="52" height="52" fill="white" transform="translate(0.983887 0.603516)" />
            </clipPath>
          </defs>
        </>
      );
      break;
    case "selectArrow":
      data = (
        <g id="arrow_back" data-name="arrow back" transform="translate(0 9) rotate(-90)">
          <path
            id="arrow_back-2"
            data-name="arrow back"
            d="M7.5,0A1.362,1.362,0,0,0,6.45.45l-6,6a1.45,1.45,0,0,0,0,2.1,1.45,1.45,0,0,0,2.1,0L7.5,3.6l4.95,4.95a1.485,1.485,0,0,0,2.1-2.1l-6-6A1.362,1.362,0,0,0,7.5,0Z"
            transform="translate(0 15) rotate(-90)"
          />
        </g>
      );
      break;
    case "selectArrowSmall":
      data = (
        <g id="Chevron-down" transform="translate(-328 -444)">
          <rect id="Boundary" width="24" height="24" transform="translate(352 468) rotate(180)" fill="none" />
          <path
            id="_Color"
            data-name=" ↳Color"
            d="M10.59,7.4,6,2.826,1.41,7.4,0,5.992,6,0l6,5.992Z"
            transform="translate(346 459.7) rotate(180)"
            fill="#60677d"
          />
        </g>
      );
      break;
    case "thumbDel":
      data = (
        <>
          <g id="타원_93" data-name="타원 93" fill="#626a6f" stroke="#626a6f" strokeWidth="1">
            <circle cx="12" cy="12" r="12" stroke="none" />
            <circle cx="12" cy="12" r="11.5" fill="none" />
          </g>
          <g id="그룹_3690" data-name="그룹 3690" transform="translate(-284.629 -92.589)">
            <path
              id="패스_2892"
              data-name="패스 2892"
              d="M7188.628,100.589l8,8"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
            <path
              id="패스_2893"
              data-name="패스 2893"
              d="M7196.628,100.589l-8,8"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
        </>
      );
      break;
    case "trDel":
      data = (
        <>
          <g id="그룹_3690" data-name="그룹 3690" transform="translate(-288.628 -96.589)">
            <path
              id="패스_2892"
              data-name="패스 2892"
              d="M7188.629,100.589l12,12"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#626a6f"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
            <path
              id="패스_2893"
              data-name="패스 2893"
              d="M7200.628,100.589l-12,12"
              transform="translate(-6896 0)"
              fill="none"
              stroke="#626a6f"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
          <rect id="Boundary" width="20" height="20" fill="none" />
        </>
      );
      break;
    case "star":
      data = (
        <>
          <rect id="Boundary" width="20" height="20" fill="none" />
          <path
            id="_Color"
            data-name=" ↳Color"
            d="M8,12.055,12.944,15,11.632,9.45,16,5.716l-5.752-.482L8,0,5.752,5.234,0,5.716,4.368,9.45,3.056,15Z"
            transform="translate(2 2)"
          />
        </>
      );
      break;
    case "bigStar":
      data = (
        <path
          d="M24.8252 0.080166L30.5527 17.8593L48.9887 17.8267L34.0926 28.8474L39.8201 46.6266L24.8862 35.6586L9.99007 46.6793L15.6566 28.88L0.722669 17.912L19.1587 17.8794L24.8252 0.080166Z"
          fill="#E7E9EF"
        />
      );
      break;
    case "bigStarActive":
      data = (
        <path
          d="M24.8252 0.080166L30.5527 17.8593L48.9887 17.8267L34.0926 28.8474L39.8201 46.6266L24.8862 35.6586L9.99007 46.6793L15.6566 28.88L0.722669 17.912L19.1587 17.8794L24.8252 0.080166Z"
          fill="#00263E"
        />
      );
      break;
    case "warning":
      data = (
        <>
          <rect id="Boundary" width="48" height="48" fill="none" />
          <path
            id="_Color"
            data-name=" ↳Color"
            d="M21.978,44A22,22,0,1,1,44,22,22.014,22.014,0,0,1,21.978,44ZM22,4.4A17.6,17.6,0,1,0,39.6,22,17.62,17.62,0,0,0,22,4.4ZM24.2,33H19.8V28.6h4.4V33Zm0-8.8H19.8V11h4.4V24.2Z"
            transform="translate(2 2)"
            fill="#f55555"
          />
        </>
      );
      break;
    case "comingSoon":
      data = (
        <>
          <defs>
            <filter id="패스_2948" x="0" y="0" width="230" height="230" filterUnits="userSpaceOnUse">
              <feOffset dy="5" />
              <feGaussianBlur stdDeviation="5" result="blur" />
              <feFlood floodColor="#ebebeb" />
              <feComposite operator="in" in2="blur" />
              <feComposite in="SourceGraphic" />
            </filter>
            <clipPath id="clip-path">
              <rect
                id="사각형_2442"
                data-name="사각형 2442"
                width="144.244"
                height="125.94"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </clipPath>
          </defs>
          <g id="구성_요소_54_1" data-name="구성 요소 54 – 1" transform="translate(15 10)">
            <g transform="matrix(1, 0, 0, 1, -15, -10)" filter="url(#패스_2948)">
              <path id="패스_2948-2" data-name="패스 2948" d="M100,0A100,100,0,1,1,0,100,100,100,0,0,1,100,0Z" transform="translate(15 10)" fill="#fff" />
            </g>
            <g id="구성_요소_53_2" data-name="구성 요소 53 – 2" transform="translate(6.924 6.651)">
              <g id="그룹_4048" data-name="그룹 4048" transform="translate(21.403 31.767)">
                <g id="그룹_4005" data-name="그룹 4005">
                  <g id="그룹_4004" data-name="그룹 4004" clipPath="url(#clip-path)">
                    <path
                      id="패스_2912"
                      data-name="패스 2912"
                      d="M82.8,113.54l-4.255-15.5L40.287,108.707a1.96,1.96,0,0,1-2.408-1.367L32.417,87.654,18.8,91.267,26.995,120.8a7.866,7.866,0,0,0,9.682,5.476Z"
                      transform="translate(-6.237 -29.08)"
                      fill="#fff"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2913"
                      data-name="패스 2913"
                      d="M82.8,113.54l-4.255-15.5L40.287,108.707a1.96,1.96,0,0,1-2.408-1.367L32.417,87.654,18.8,91.267,26.995,120.8a7.866,7.866,0,0,0,9.682,5.476Z"
                      transform="translate(-6.237 -29.08)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2914"
                      data-name="패스 2914"
                      d="M140.6,100.093,2.41,78.027a1.673,1.673,0,0,1-1.389-1.916L2.39,67.537a1.673,1.673,0,0,1,1.917-1.388L142.5,88.215a1.673,1.673,0,0,1,1.389,1.917L142.518,98.7A1.673,1.673,0,0,1,140.6,100.093Z"
                      transform="translate(-0.332 -21.939)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2915"
                      data-name="패스 2915"
                      d="M170.877,127.1c10.09-4.723,19.7-22.39,23.235-44.533,3.552-22.246-.129-42.1-8.325-49.655a93.506,93.506,0,0,1-.078,31.225q-.546,3.422-1.282,6.691l-6.678-1.066a1.674,1.674,0,0,0-1.917,1.389L173.2,87.644a1.674,1.674,0,0,0,1.389,1.917l6.654,1.063c-.219,2.337-.513,4.712-.9,7.119a93.915,93.915,0,0,1-9.466,29.36"
                      transform="translate(-56.691 -10.92)"
                      fill="#1a1818"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2916"
                      data-name="패스 2916"
                      d="M170.877,127.1c10.09-4.723,19.7-22.39,23.235-44.533,3.552-22.246-.129-42.1-8.325-49.655a93.506,93.506,0,0,1-.078,31.225q-.546,3.422-1.282,6.691l-6.678-1.066a1.674,1.674,0,0,0-1.917,1.389L173.2,87.644a1.674,1.674,0,0,0,1.389,1.917l6.654,1.063c-.219,2.337-.513,4.712-.9,7.119A93.915,93.915,0,0,1,170.877,127.1Z"
                      transform="translate(-56.691 -10.92)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2917"
                      data-name="패스 2917"
                      d="M23.4,84.718h0a8.353,8.353,0,0,1-8.353-8.353V69.683a8.353,8.353,0,1,1,16.706,0v6.682A8.353,8.353,0,0,1,23.4,84.718"
                      transform="translate(-4.993 -20.347)"
                      fill="#fff"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2918"
                      data-name="패스 2918"
                      d="M23.4,84.718h0a8.353,8.353,0,0,1-8.353-8.353V69.683a8.353,8.353,0,1,1,16.706,0v6.682A8.353,8.353,0,0,1,23.4,84.718Z"
                      transform="translate(-4.993 -20.347)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2919"
                      data-name="패스 2919"
                      d="M79.443,155.14V143.647c0-4.656.078-9.993.427-15.416a80.307,80.307,0,0,1,9.623-33.1h19.774a9.014,9.014,0,0,1,8.6,6.3L134.6,154.56a1.7,1.7,0,0,1-1.6,2.275H81.137a1.694,1.694,0,0,1-1.694-1.694"
                      transform="translate(-26.356 -31.563)"
                      fill="#fff"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2920"
                      data-name="패스 2920"
                      d="M79.443,155.14V143.647c0-4.656.078-9.993.427-15.416a80.307,80.307,0,0,1,9.623-33.1h19.774a9.014,9.014,0,0,1,8.6,6.3L134.6,154.56a1.7,1.7,0,0,1-1.6,2.275H81.137A1.694,1.694,0,0,1,79.443,155.14Z"
                      transform="translate(-26.356 -31.563)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2921"
                      data-name="패스 2921"
                      d="M122.731,43.362a29.07,29.07,0,1,1-29.07-29.251,29.161,29.161,0,0,1,29.07,29.251"
                      transform="translate(-21.429 -4.682)"
                      fill="#fff"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <ellipse
                      id="타원_151"
                      data-name="타원 151"
                      cx="29.07"
                      cy="29.251"
                      rx="29.07"
                      ry="29.251"
                      transform="translate(43.163 9.429)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <line
                      id="선_246"
                      data-name="선 246"
                      x2="4.277"
                      y2="19.089"
                      transform="translate(85.344 106.183)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2922"
                      data-name="패스 2922"
                      d="M120.352,138.778l19.753-2.884a1.606,1.606,0,0,0,1.33-1.965l-6.7-27.907a11.415,11.415,0,0,0-22.225,5.22l6.042,26.306a1.606,1.606,0,0,0,1.8,1.23"
                      transform="translate(-37.23 -32.271)"
                      fill="#fff"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2923"
                      data-name="패스 2923"
                      d="M120.352,138.778l19.753-2.884a1.606,1.606,0,0,0,1.33-1.965l-6.7-27.907a11.415,11.415,0,0,0-22.225,5.22l6.042,26.306A1.606,1.606,0,0,0,120.352,138.778Z"
                      transform="translate(-37.23 -32.271)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2924"
                      data-name="패스 2924"
                      d="M139.5,59.915,109.459,56.16v2.851a3.442,3.442,0,0,0,3.442,3.442h.77a5.9,5.9,0,0,1,5.9,5.9,6.108,6.108,0,0,1-6.108,6.108.284.284,0,0,0-.284.284V85.454C126.055,83.766,136.5,73.432,139.5,59.915"
                      transform="translate(-36.314 -18.632)"
                      fill="#1a1818"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2925"
                      data-name="패스 2925"
                      d="M139.5,59.915,109.459,56.16v2.851a3.442,3.442,0,0,0,3.442,3.442h.77a5.9,5.9,0,0,1,5.9,5.9,6.108,6.108,0,0,1-6.108,6.108.284.284,0,0,0-.284.284V85.454C126.055,83.766,136.5,73.432,139.5,59.915Z"
                      transform="translate(-36.314 -18.632)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2926"
                      data-name="패스 2926"
                      d="M82.7,70.785h0a1.67,1.67,0,0,1-1.671-1.671v-.668a1.671,1.671,0,1,1,3.341,0v.668A1.67,1.67,0,0,1,82.7,70.785"
                      transform="translate(-26.882 -22.154)"
                      fill="#1a1818"
                    />
                    <path
                      id="패스_2927"
                      data-name="패스 2927"
                      d="M81.005,63.495a4.384,4.384,0,0,1,4.492,1.09"
                      transform="translate(-26.874 -21.007)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2928"
                      data-name="패스 2928"
                      d="M94.233,1.189C80.2,1.189,68.361,11.4,64.583,25.4l60.508,7.563c-.952-17.72-14.4-31.771-30.858-31.771"
                      transform="translate(-21.426 -0.394)"
                      fill="#fdea7f"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2929"
                      data-name="패스 2929"
                      d="M94.233,1.189C80.2,1.189,68.361,11.4,64.583,25.4l60.508,7.563C124.139,15.24,110.69,1.189,94.233,1.189Z"
                      transform="translate(-21.426 -0.394)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2930"
                      data-name="패스 2930"
                      d="M126.383,44.689l-4.91-.613L60.966,36.512,56.091,35.9A1.333,1.333,0,0,0,54.6,37.06l-.913,7.3a1.334,1.334,0,0,0,1.158,1.488l4.859.607,60.947,7.618,4.487.561a1.333,1.333,0,0,0,1.488-1.157l.913-7.3a1.334,1.334,0,0,0-1.158-1.489"
                      transform="translate(-17.809 -11.908)"
                      fill="#fdea7f"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2931"
                      data-name="패스 2931"
                      d="M126.383,44.689l-4.91-.613L60.966,36.512,56.091,35.9A1.333,1.333,0,0,0,54.6,37.06l-.913,7.3a1.334,1.334,0,0,0,1.158,1.488l4.859.607,60.947,7.618,4.487.561a1.333,1.333,0,0,0,1.488-1.157l.913-7.3A1.334,1.334,0,0,0,126.383,44.689Z"
                      transform="translate(-17.809 -11.908)"
                      fill="none"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2932"
                      data-name="패스 2932"
                      d="M95.152,33.748h0a2,2,0,1,1,2-2,2,2,0,0,1-2,2"
                      transform="translate(-30.903 -9.866)"
                      fill="#1a1818"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2933"
                      data-name="패스 2933"
                      d="M110.521,36.748h0a2,2,0,1,1,2-2,2,2,0,0,1-2,2"
                      transform="translate(-36.002 -11.613)"
                      fill="#1a1818"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2934"
                      data-name="패스 2934"
                      d="M126.087,39.748h0a2,2,0,1,1,2-2,2,2,0,0,1-2,2"
                      transform="translate(-41.166 -12.609)"
                      fill="#1a1818"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2935"
                      data-name="패스 2935"
                      d="M97.733,10.053C106.343,10.9,111,15,113.154,17.447a.839.839,0,0,0,1.131.125l6.749-4.982a29.207,29.207,0,0,0-46.283-.4l5.105,5.23a.834.834,0,0,0,1.189.01c1.993-1.993,8.836-8.15,16.688-7.376"
                      transform="translate(-24.8 -0.332)"
                      fill="#d7ebff"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="패스_2936"
                      data-name="패스 2936"
                      d="M97.733,10.053C106.343,10.9,111,15,113.154,17.447a.839.839,0,0,0,1.131.125l6.749-4.982a29.207,29.207,0,0,0-46.283-.4l5.105,5.23a.834.834,0,0,0,1.189.01C83.038,15.435,89.881,9.279,97.733,10.053Z"
                      transform="translate(-24.8 -0.332)"
                      fill="#fdea7f"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                  </g>
                </g>
              </g>
              <rect id="사각형_2477" data-name="사각형 2477" width="186.349" height="186.349" fill="none" />
            </g>
          </g>
        </>
      );
      break;
    case "error":
      data = (
        <>
          <defs>
            <filter id="패스_2954" x="0" y="0" width="230" height="230" filterUnits="userSpaceOnUse">
              <feOffset dy="5" />
              <feGaussianBlur stdDeviation="5" result="blur" />
              <feFlood floodColor="#ebebeb" />
              <feComposite operator="in" in2="blur" />
              <feComposite in="SourceGraphic" />
            </filter>
            <clipPath id="clip-path">
              <rect id="사각형_2478" data-name="사각형 2478" width="141.642" height="93.811" fill="none" />
            </clipPath>
          </defs>
          <g id="구성_요소_60_1" data-name="구성 요소 60 – 1" transform="translate(15 10)">
            <g transform="matrix(1, 0, 0, 1, -15, -10)" filter="url(#패스_2954)">
              <path id="패스_2954-2" data-name="패스 2954" d="M100,0A100,100,0,1,1,0,100,100,100,0,0,1,100,0Z" transform="translate(15 10)" fill="#fff" />
            </g>
            <path
              id="패스_2953"
              data-name="패스 2953"
              d="M125.645,46.755A24.045,24.045,0,0,0,105.877,30.1a35.225,35.225,0,0,0-67.985-5.367A24.018,24.018,0,0,0,15.948,46.923,24.023,24.023,0,0,0,25.023,93.19H117a24.023,24.023,0,0,0,8.647-46.435Z"
              transform="translate(40.497 46.102)"
              fill="#b8d6ff"
              opacity="0.5"
            />
            <g id="그룹_4050" data-name="그룹 4050" transform="translate(24.483 40)">
              <g id="그룹_4049" data-name="그룹 4049" transform="translate(0 0)" clipPath="url(#clip-path)">
                <path
                  id="패스_2949"
                  data-name="패스 2949"
                  d="M125.645,46.755A24.045,24.045,0,0,0,105.877,30.1a35.225,35.225,0,0,0-67.985-5.367A24.018,24.018,0,0,0,15.948,46.923,24.023,24.023,0,0,0,25.023,93.19H117a24.023,24.023,0,0,0,8.647-46.435Z"
                  transform="translate(-0.19 -0.19)"
                  fill="none"
                  stroke="#1a1818"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2.5"
                />
                <path
                  id="패스_2950"
                  data-name="패스 2950"
                  d="M66.772,55.324a5.62,5.62,0,1,1-5.62-5.62,5.621,5.621,0,0,1,5.62,5.62"
                  transform="translate(-10.542 -9.436)"
                  fill="#1a1818"
                />
                <path
                  id="패스_2951"
                  data-name="패스 2951"
                  d="M116.371,55.324a5.62,5.62,0,1,1-5.62-5.62,5.62,5.62,0,0,1,5.62,5.62"
                  transform="translate(-19.958 -9.436)"
                  fill="#1a1818"
                />
                <path
                  id="패스_2952"
                  data-name="패스 2952"
                  d="M52.374,89.895a43.519,43.519,0,0,1,56.777,0"
                  transform="translate(-9.942 -15.065)"
                  fill="none"
                  stroke="#1a1818"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2.5"
                />
              </g>
            </g>
            <rect id="사각형_2479" data-name="사각형 2479" width="141.642" height="93.811" transform="translate(24.483 40)" fill="none" />
          </g>
        </>
      );
      break;
    case "pageLeft":
      data = (
        <>
          <rect id="사각형_2455" data-name="사각형 2455" width="40" height="40" fill="none" />
          <g id="arrow_back" data-name="arrow back" transform="translate(16.4 14)">
            <path
              id="arrow_back-2"
              data-name="arrow back"
              d="M6,7.2a1.089,1.089,0,0,1-.84-.36L.36,2.04A1.16,1.16,0,0,1,.36.36a1.16,1.16,0,0,1,1.68,0L6,4.32,9.96.36a1.16,1.16,0,0,1,1.68,0,1.16,1.16,0,0,1,0,1.68l-4.8,4.8A1.089,1.089,0,0,1,6,7.2Z"
              transform="translate(7.2) rotate(90)"
              fill="#c3c8c8"
            />
          </g>
        </>
      );
      break;
    case "pageRight":
      data = (
        <>
          <rect id="사각형_2462" data-name="사각형 2462" width="40" height="40" fill="none" />
          <g id="arrow_back" data-name="arrow back" transform="translate(16.4 13.5)">
            <path
              id="arrow_back-2"
              data-name="arrow back"
              d="M6,0a1.089,1.089,0,0,0-.84.36L.36,5.16a1.16,1.16,0,0,0,0,1.68,1.16,1.16,0,0,0,1.68,0L6,2.88,9.96,6.84a1.188,1.188,0,0,0,1.68-1.68L6.84.36A1.089,1.089,0,0,0,6,0Z"
              transform="translate(7.2) rotate(90)"
              fill="#c3c8c8"
            />
          </g>
        </>
      );
      break;
    case "pageFirst":
      data = (
        <>
          <rect id="사각형_2455" data-name="사각형 2455" width="40" height="40" fill="none" />
          <g id="그룹_4266" data-name="그룹 4266" transform="translate(4411.2 1816)">
            <g id="arrow_back" data-name="arrow back" transform="translate(-4398.2 -1802)">
              <path
                id="arrow_back-2"
                data-name="arrow back"
                d="M6,7.2a1.089,1.089,0,0,1-.84-.36L.36,2.04A1.16,1.16,0,0,1,.36.36a1.16,1.16,0,0,1,1.68,0L6,4.32,9.96.36a1.16,1.16,0,0,1,1.68,0,1.16,1.16,0,0,1,0,1.68l-4.8,4.8A1.089,1.089,0,0,1,6,7.2Z"
                transform="translate(7.2) rotate(90)"
                fill="#c3c8c8"
              />
            </g>
            <g id="arrow_back-3" data-name="arrow back" transform="translate(-4391 -1802)">
              <path
                id="arrow_back-4"
                data-name="arrow back"
                d="M6,7.2a1.089,1.089,0,0,1-.84-.36L.36,2.04A1.16,1.16,0,0,1,.36.36a1.16,1.16,0,0,1,1.68,0L6,4.32,9.96.36a1.16,1.16,0,0,1,1.68,0,1.16,1.16,0,0,1,0,1.68l-4.8,4.8A1.089,1.089,0,0,1,6,7.2Z"
                transform="translate(7.2) rotate(90)"
                fill="#c3c8c8"
              />
            </g>
          </g>
        </>
      );
      break;
    case "pageLast":
      data = (
        <>
          <rect id="사각형_2462" data-name="사각형 2462" width="40" height="40" fill="none" />
          <g id="그룹_4267" data-name="그룹 4267" transform="translate(4371.2 1816)">
            <g id="arrow_back" data-name="arrow back" transform="translate(-4358.2 -1802)">
              <path
                id="arrow_back-2"
                data-name="arrow back"
                d="M6,0a1.089,1.089,0,0,0-.84.36L.36,5.16a1.16,1.16,0,0,0,0,1.68,1.16,1.16,0,0,0,1.68,0L6,2.88,9.96,6.84a1.188,1.188,0,0,0,1.68-1.68L6.84.36A1.089,1.089,0,0,0,6,0Z"
                transform="translate(7.2) rotate(90)"
                fill="#c3c8c8"
              />
            </g>
            <g id="arrow_back-3" data-name="arrow back" transform="translate(-4351 -1802)">
              <path
                id="arrow_back-4"
                data-name="arrow back"
                d="M6,0a1.089,1.089,0,0,0-.84.36L.36,5.16a1.16,1.16,0,0,0,0,1.68,1.16,1.16,0,0,0,1.68,0L6,2.88,9.96,6.84a1.188,1.188,0,0,0,1.68-1.68L6.84.36A1.089,1.089,0,0,0,6,0Z"
                transform="translate(7.2) rotate(90)"
                fill="#c3c8c8"
              />
            </g>
          </g>
        </>
      );
      break;
    case "datapicker":
      data = (
        <>
          <g id="Icons_Navigation_icon_12_states_" data-name="Icons / Navigation icon (12 states)" transform="translate(1 1)">
            <g id="ic-calendar">
              <path id="패스_445" data-name="패스 445" d="M0,0H21.5V21.5H0Z" fill="none" />
              <rect
                id="사각형_608"
                data-name="사각형 608"
                width="15"
                height="15"
                rx="2"
                transform="translate(3 3.85)"
                fill="none"
                stroke="#c3c8c8"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <line
                id="선_31"
                data-name="선 31"
                y2="5"
                transform="translate(14 2)"
                fill="none"
                stroke="#c3c8c8"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <line
                id="선_32"
                data-name="선 32"
                y2="5"
                transform="translate(7 2)"
                fill="none"
                stroke="#c3c8c8"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <line
                id="선_33"
                data-name="선 33"
                x2="15"
                transform="translate(3 9.931)"
                fill="none"
                stroke="#c3c8c8"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <rect id="사각형_609" data-name="사각형 609" width="2" height="2" transform="translate(7 12.901)" fill="#c3c8c8" />
            </g>
          </g>
          <rect id="사각형_2473" data-name="사각형 2473" width="24" height="24" fill="none" />
        </>
      );
      break;
    default:
      data = <></>;
      break;
  }
  return (
    <svg
      className={className}
      xmlns={xmlns}
      style={style}
      width={`${width}px` || "current"}
      height={`${height}px` || "current"}
      viewBox={viewBox || "current"}
      version={version}
    >
      {data}
    </svg>
  );
}

SVG.defaultProps = {
  name: null,
  className: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  version: "1.1",
};
